import React from 'react';

const LayoutContext = React.createContext({
  shipmentMetadataGroupings: [],
  isLoading: true,
  setShipmentMetadataGroupings: () => { },
});

export default LayoutContext;
